import { FC } from 'react';

const TooltipContent: FC = () => (
  <p>
    This template contains premium content. You can replace it with free stocks
    or your own media.
  </p>
);

export default TooltipContent;
